var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBoldWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2328 9.14824C5.19336 9.10982 5.02472 8.96475 4.886 8.82962C4.01356 8.03737 2.58556 5.97064 2.14968 4.88891C2.07964 4.72463 1.9314 4.3093 1.92188 4.08739C1.92188 3.87476 1.97083 3.67206 2.07012 3.47863C2.20884 3.23751 2.42711 3.04409 2.68484 2.9381C2.86367 2.86987 3.39884 2.76389 3.40836 2.76389C3.99384 2.6579 4.94516 2.59961 5.99644 2.59961C6.99808 2.59961 7.91063 2.6579 8.50495 2.74468C8.51447 2.75461 9.17952 2.8606 9.40732 2.97652C9.82348 3.18916 10.0819 3.60449 10.0819 4.04897V4.08739C10.0717 4.37687 9.81327 4.98563 9.80375 4.98563C9.36719 6.00906 8.00923 8.0281 7.10687 8.83955C7.10687 8.83955 6.875 9.06809 6.73015 9.16745C6.52208 9.32245 6.26436 9.39929 6.00664 9.39929C5.719 9.39929 5.45108 9.31252 5.2328 9.14824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBoldWhite);
export default __webpack_public_path__ + "static/media/arrow_down_bold_white.18eef71d.svg";
export { ForwardRef as ReactComponent };